<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <AuthLogo/>
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid"
                                                                                               :src="`${publicPath}app-assets/images/pages/login-v2.svg`"
                                                                                               alt="Login V2"/></div>
            </div>
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h3 class="card-title font-weight-bold mb-1"><img class="w-75"
                                                                  :src="`${publicPath}images/vaults-authlogo.png`"></h3>
                <h3 class="card-title font-weight-bold mb-1">Welcome to VaultsPay! 👋</h3>
                <p class="card-text mb-2">Please Setup you data</p>
                <Form class="auth-login-form mt-2" @submit="sendCall" v-slot="{ errors }">
                  <div class="form-group" v-for="({ input_type, name, input_attributes,id }, index) in fields"
                       :key="index">
                    <template v-if="input_type.type == 'checkbox'">
                      <div class="custom-control custom-checkbox">
                        <Field
                            class="custom-control-input"
                            :type="input_type.type"
                            :id="id"
                            :name="name.replace(/ /g,'_')+'_'+id"
                            :rules="input_attributes.required? 'required': ''"
                            :value="1"

                        />
                        <label class="custom-control-label" :for="id">{{ name }}</label>

                      </div>
                      <span v-if="errors[name.replace(/ /g,'_')+'_'+id]">{{
                          errors[name.replace(/ /g, '_') + '_' + id].replace(name.replace(/ /g, '_') + '_' + id, name)
                        }}</span>
                    </template>
                    <template v-else-if="input_type.type == 'radio'">
                      <div class="form-check">
                        <Field
                            class="form-check-input"
                            :type="input_type.type"
                            :id="id"
                            :name="name.replace(/ /g,'_')+'_'+id"
                            :rules="input_attributes.required? 'required': ''"
                            :value="1"
                        />
                        <label class="form-check-label" :for="id">{{ name }}</label>
                      </div>
                      <span v-if="errors[name.replace(/ /g,'_')+'_'+id]">{{ resolveErrorMsg(errors, name, id) }}</span>
                    </template>
                    <template v-else-if="input_type.type == 'file'">
                      <label class="form-label" :for="id">{{ name }}</label>
                      <div class="custom-file">
                        <Field
                            class="custom-file-input"
                            :type="input_type.type"
                            :id="id"
                            :name="name.replace(/ /g,'_')+'_'+id"
                            :rules="input_attributes.required? 'required': ''"
                            @change="onFileChanged($event, id)"
                        />
                        <label class="custom-file-label" :ref="'file_label_'+id" :for="id">Choose File</label>
                      </div>
                      <span v-if="errors[name.replace(/ /g,'_')+'_'+id]">{{ resolveErrorMsg(errors, name, id) }}</span>
                      <div v-show="fileLoader" class="spinner-border text-primary spinner-border-sm"></div>

                    </template>
                    <template v-else>
                      <label class="form-label" :for="id">{{ name }}</label>
                      <Field
                          class="form-control"
                          :type="input_type.type"
                          :id="id"
                          :name="name.replace(/ /g,'_')+'_'+id"
                          :rules="input_attributes.required? 'required': ''"
                      />
                      <span v-if="errors[name.replace(/ /g,'_')+'_'+id]">{{ resolveErrorMsg(errors, name, id) }}</span>

                    </template>
                  </div>
                  <div class="mt-2">
                    <Button class="btn btn-primary btn-block" :loading="loader">Submit</Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.getUserInputs()
  },
  data() {
    return {
      loader: false,
      email: '',
      fields: [],
      fileLoader : false

    }
  },
  methods: {
    resolveErrorMsg(errors, name, id) {
      return errors[name.replace(/ /g, '_') + '_' + id].replace(name.replace(/ /g, '_') + '_' + id, name)
    },
    getUserInputs() {

      this.makeRequest('post', 'v1/get-user-kyc', {}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            this.fields = data.inputs
          }
        }

      });

    },
    onFileChanged: function (event, id) {
      let file = event.target.files[0]
      let element = 'file_label_'+id
      this.$refs[element].innerHTML = typeof(file) != "undefined" ? file.name : 'Choose File'
      if(typeof(file) != 'undefined'){
        this.submitFile(file,id)
      }
    },
    submitFile(file,id){
      let data = new FormData();
      data.append("application", "android");
      data.append("applicationVersion", "1.33");
      data.append("deviceId", "XXXXXXXXXXXXXXXXXXXXXXXX");
      data.append("deviceDetail", "android s4 etc");
      data.append("latitude", "");
      data.append("longitude", "");
      data.append("file", file, file.name);
      data.append("inputId", id);
      data.append("uri", 'v1/upload-user-kyc-file');

      this.fileLoader = true
      this.makeRequest('post', 'v1/upload-user-kyc-file', data).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code != 200) {
            // window.location.reload()
          }
        }

        this.fileLoader = false

      });

    },
    sendCall(values) {

      //for checkbox and radio fields
      for (let [key, value] of Object.entries(values)) {
        if (typeof (value) == 'undefined') {
          values[key] = 0
        }
      }
      let dataToSend = []

      for (let [key, fieldValue] of Object.entries(this.fields)) {
        let name = fieldValue.name.replace(/ /g, '_') + '_' + fieldValue.id
        if (values[name]) {
          if (fieldValue.input_type.type != 'file') {
            dataToSend.push({inputId: fieldValue.id, value: values[name]})
          }

        }
      }
      this.loader = true
      this.makeRequest('post', 'v1/manage-user-kyc', {kyc: JSON.stringify(dataToSend)}).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            var newUrl = window.location.href.replace('auth/user-input', 'app/');

            window.location.href = newUrl
          }
        }

      });

    },
  },
}
</script>


